import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { map } from "rxjs/operators";
import "rxjs/add/operator/toPromise";
import { LocalService } from "app/services/local.service";
@Injectable({
  providedIn: "root",
})
export class OrdersService {
  apiUrl = "";
  // JSON.parse(localStorage.getItem("client"))["apiUrl"] || environment.apiUrl;

  constructor(
    private http: HttpClient,
    public localService: LocalService,
  ) {
    if (localStorage.getItem("client")) {
      this.apiUrl = JSON.parse(localStorage.getItem("client"))["apiUrl"];
    } else {
      this.apiUrl = environment.apiUrl;
    }
  }

  getOrders(search): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "order/getSellerOrders", search, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getOrdersPage(search, start, pagesize): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl +
          "order/getSellerOrders?start=" +
          start +
          "&limit=" +
          pagesize,
        search,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }

  getOrderStatus(type = ""): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    let url = this.apiUrl + "order/getOrderstatus";
    if (type && type.length > 0) {
      url = url + "?type=" + type;
    }
    return this.http
      .get(url, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  createOrderStatus(recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(this.apiUrl + "order/createOrderStatus", recordData, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateOrderStatus(recordId, recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "order/updateOrderStatus?orderStatusID=" + recordId,
        recordData,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  deleteOrderStatus(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .delete(
        this.apiUrl + "order/removeOrderStatus?orderStatusID=" + recordId,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  getOrderDetails(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "order/getOrderDetailsComplete?orderID=" + recordId, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }
  updateOrderDetails(recordId, record): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "order/updateOrderPlacedDetails?orderID=" + recordId,
        record,
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
  createOrderTimeline(recordData): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    // console.log(recordData)
    return this.http
      .post(this.apiUrl + "order/createOrderTimeline", recordData, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  getOrderTimeline(recordId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .get(this.apiUrl + "order/getOrderTimeline?orderID=" + recordId, {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //To get Completed Order Count
  getOrderCount(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "order/getOrderCount", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  //To get Dashboard Page Todays Order
  getTodaysOrderStatus(): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .get(this.apiUrl + "order/getTodaysOrderStatus", {
        headers: headers,
      })
      .map((response) => response)
      .toPromise();
  }

  // Auto Complete Search for Orders

  getOrderID(term: string) {
    console.log(term);
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });
    return this.http
      .post(
        this.apiUrl + "order/searchOrder",
        { order_id: term },
        {
          headers: headers,
        },
      )
      .pipe(
        map((response) =>
          response["Data"]
            .filter((option) => {
              // console.log(option);
              return (
                option.shortOrderID
                  .toLowerCase()
                  .indexOf(term.toLowerCase()) === 0
              );
            })
            .slice(0, 10),
        ),
      );
  }

  // /**
  //  * Filter Order By User
  //  */
  // filterOrderByUser(term) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json',
  //     'x-access-token': localStorage.getItem('token')
  //   });
  //   return this.http
  //     .post(this.apiUrl + 'order/searchOrder', { order_id: term }, {
  //       headers: headers
  //     }).pipe(
  //       map(response => response['Data'].filter(option => {
  //         return option.shortOrderID.toLowerCase().indexOf(term.toLowerCase()) === 0
  //       }).slice(0, 10))
  //     )
  // }

  assignRider(riderId): Promise<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      "x-access-token": localStorage.getItem("token"),
    });

    return this.http
      .post(
        this.apiUrl + "order/addShippingDetails?orderID=" + riderId,
        {},
        {
          headers: headers,
        },
      )
      .map((response) => response)
      .toPromise();
  }
}
